'use client';

import { useEffect } from 'react';

const IOSToast = ({ isOpen, message, onClose, duration = 3000 }) => {
useEffect(() => {
if (isOpen) {
const timer = setTimeout(() => {
onClose();
}, duration);
return () => clearTimeout(timer);
}
}, [isOpen, duration, onClose]);

if (!isOpen) return null;

return (
<div className="fixed top-10 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none transition-all">
    <div className="bg-[#F2F2F2]/90 dark:bg-[#1E1E1E]/90 backdrop-blur-xl px-6 py-3 rounded-full shadow-lg animate-in slide-in-from-top-8 fade-in duration-300 border border-[#3C3C43]/10 dark:border-[#545458]/30">
        <p className="text-[15px] font-medium text-black dark:text-white text-center leading-tight">
            {message}
        </p>
    </div>
</div>
);
};

export default IOSToast;
